import { Component, Input } from '@angular/core';
import { ShiveGridWrapperComponent } from '../../shive-controls/shive-grid/shive-grid-wrapper.component';
import { UserOperation } from '../../../../core/enums/user-operation';
import { faEllipsis as faEllipsisRegular } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-context-menu-anchor',
  templateUrl: './context-menu-anchor.component.html',
  standalone: false,
})
export class ContextMenuAnchorComponent {
  @Input() gridWrapperComponent!: ShiveGridWrapperComponent;
  @Input() dataItem!: unknown;
  @Input() disabled = false;
  public readonly faEllipsis = faEllipsisRegular;
  public readonly UserOperation = UserOperation;
}
